var currentClubId = "";
// No slash before the query string: "playerSelectors/?x" 301s to "playerSelectors?x".
var playersListUrl = appBaseUrl + "playerSelectors?userReferenceId=" + userReferenceId + "&club_slug=" + club_slug+ "&product_id=" + product_id;
var playersData = {
    players: [],
    siteBaseUrl: siteBaseUrl,
};
$(function() {
    if (document.querySelector('.custom_players_template') !== null) {
        playersList();
    }
    if (document.querySelector('.custom_players_dd_template') !== null) {
        playersList('dropdown');
    }
  
  if (document.querySelector('#customize_prod_option') !== null) {
    var isCustomval = urlParams.get('isCustom');
    if (isCustomval !== null) {
      $("#customize_prod_option").val(isCustomval);
    }
  }

  if ($('body').data('template') == "product") {
    setTimeout(function(){
      $('.variants_dropdown').each(function() {
        variantType = $(this).attr("data-name");
       // alert(variantType);
        if (variantType == "Size") {
          productOptions = $(this).find('option').length;
          $(this).prepend('<option value="">Select a ' +variantType + '</option>')
          .val('')
          .trigger('change');
        }
      });
    }, 100);
      
  } else {
  	$('.variants_dropdown').each(function() {
      variantType = $(this).attr("data-name");
      if (variantType == "Size") {
        productOptions = $(this).find('option').length;
        $(this).prepend('<option value="">Select a ' +variantType + '</option>')
        .val('')
        .trigger('change');
      }
    });
  }
  
});

function dropdownplayersListCallback(data) {
    if (document.querySelector('.custom_players_dd_template') !== null) {
        playersData.players = data;     
      	playersData.previouslySelected = getCookie("previouslySelected");
      	playersData.currentlySelected = getCookie("currentlySelected");
      	playersData.overallSelected = getCookie("overallSelected");
        var source = document.querySelector(".custom_players_dd_template").innerHTML;
        var template = Handlebars.compile(source);
        var html = template(playersData);
        var destination = document.querySelector(".players_dropdown");
        destination.innerHTML = html;
    }
}

function playersListCallback(data) {
  
  playersData.players = data;
  playersData.previouslySelected = getCookie("previouslySelected");
  playersData.currentlySelected = getCookie("currentlySelected");
  playersData.overallSelected = getCookie("overallSelected");
    var source = document.querySelector(".custom_players_template").innerHTML;
    var template = Handlebars.compile(source);
    var html = template(playersData);
  	if (document.querySelector('.custom_players_list1') !== null) {

    	var destination1 = document.querySelector(".custom_players_list1");
    	destination1.innerHTML = html;
    }
  
    if (document.querySelector('#warningPlayerSelection') !== null) {
      // && data.is_club=="yes"
        if (data.total_records < 1 && data.is_club=="yes") {
            $("#warningPlayerSelection").css("display", "block");
          	$(".filter-link-required").attr("data-tag","required");
          	if ($(".filter-link-required").hasClass("active") == true) {
              //$('.filter-link-required').get(0).click();
            }
          	applyRequiredTag("required", 'remove','','');
          	applyPurchasedTag('remove', '');
          
        }
      if (data.is_skip_required == 1) {
        applyRequiredTag("required", 'remove','','');
      }
        
    }

    if (lastPlayerSelectionId != "") {
        //$(".temp_player_btn_" + lastPlayerSelectionId).trigger("click");
        lastPlayerSelectionId = "";
        islastPlayerSelection = true;
    }
  if (playerPageLoad == false) {
    currentlySelectedId = getCookie("currentlySelected");
    //alert(currentlySelectedId);
    if (currentlySelectedId != undefined && currentlySelectedId != "") {
    	tempPlayerRowId =  currentlySelectedId;
      	$(".playerRow_"+tempPlayerRowId).addClass("player_highlight");
      	$("#player_selection_id").val(tempPlayerRowId);
      	playerPageLoad = true;
      	confirmSwitchPlayer();
    }
  }
  
  currentlySelectedItem = getCookie("currentlySelected");

  if((currentlySelectedItem == "" && data.total_records > 0) || ($(".playerRow_"+currentlySelectedItem).length < 1 && data.total_records > 0)) {
    var fristKey = '';
    for (firstKey in data.players_list) break;
    if (firstKey != "") {
      firstPlayerInfo = data.players_list[firstKey];
      if (firstPlayerInfo != "" && firstPlayerInfo != undefined) {
        firstTempPlayerId = firstPlayerInfo[0].id;
        $("#player_selection_id").val(firstTempPlayerId);
        confirmSwitchPlayer();
      }
    }
  }
  	updatePlayerSelectionText();

   
    
}

function deleteExistingPlayerSelection(tempPlayerId) {
    confirmDelete = confirm("Are you sure you want to remove this player?");
    if (confirmDelete === true) {     
      
      /* Remove deleted player cart items - start */
      currentlySelectedV = tempPlayerId;
      playersTempMapVariantsRemove = getCookie("playersTempMapVariants-"+currentlySelectedV);
      if(typeof playersTempMapVariantsRemove === 'undefined' || playersTempMapVariantsRemove === '' || playersTempMapVariantsRemove.length === 0) {
      } else {
        var remove_items = {};
        playersTempMapVariantsRemove = JSON.parse(playersTempMapVariantsRemove);
        $.each(playersTempMapVariantsRemove, function (index, remove_invalid_item) {
          remove_items[remove_invalid_item] = 0;
        });

        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          async: false,
          type: 'post',
          data: { updates: remove_items },
          success: function (itemData) {
          },
          error: function (XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            alert(response);
          }
        });

        document.cookie = "playersTempMapVariants-"+currentlySelectedV+"=;path=/";

      }
      /* Remove deleted player cart items - end */
        // No slash before the query string — avoids a 301 on every delete.
        var playerDeleteUrl = appBaseUrl + "api/playerSelectorsDestroy?userReferenceId=" + userReferenceId + "&tempPlayerId=" + tempPlayerId;
        $.ajax({
            type: 'GET',
            url: playerDeleteUrl,
            dataType: "jsonp",
        });
    }
}

function playersList(operation) {
    if (operation == undefined) {
        operation = "";
        resultFor = "product_list";
    } else {
        resultFor = "";
    }
    $.ajax({
        type: 'GET',
        url: playersListUrl + "&operation=" + operation + "&resultFor=" + resultFor,
        dataType: "jsonp",
    });
}

function playerDeleteCallback(data) {
  	previouslySelectedV = getCookie("previouslySelected");
    tempPlayerId = data.tempPlayerId;
  	

  	currentlySelectedV = getCookie("currentlySelected");
  	if (currentlySelectedV == tempPlayerId) {
  		document.cookie = "currentlySelected=;path=/";
      	tempPlayerRowId = "";
    }
  	
    if (previouslySelectedV == tempPlayerId) {
      document.cookie = "previouslySelected=;path=/";
    }
  
    $(".temp_player_" + tempPlayerId).remove();
  	

    if (document.querySelector('#selected_temp_player_info') !== null) {
        $("#selected_temp_player_info")[0].reset();
    }

    isTempPlayerSelected = 0;
    operation = "";
    $.ajax({
        type: 'GET',
        url: playersListUrl + "&operation=" + operation + "&resultFor=product_list",
        dataType: "jsonp",
    });
    if (document.querySelector('#playerSelection') !== null) {
        $('.productdetail_playerinfo input').val("");
        //playersList('dropdown');
        $.ajax({
            type: 'GET',
            url: playersListUrl + "&operation=dropdown&resultFor=",
            dataType: "jsonp",
        });
    }
    toastr.options = {
        "closeButton": true,
        "progressBar": true,
        "timeOut": "5000",
    }
    if (document.querySelector('.shopify-payment-button__button') !== null) {
        $(".shopify-payment-button__button").prop("disabled", true);
    }
    toastr['success'](data.message, "");
}
$(function() {
    var clubName = "";
    var teamName = "";
    var playerFirstName = "";
    var playerLastName = "";
    var playerNumber = "";
    var club_id = "";
    var team_id = "";
    var player_id = "";
    var player_row_id = "";

    $(document).on('change', '#playerSelection', function() {
        tempPlayerRowId = "";
        isTempPlayerSelected = 0;
        $('#playerSelection :selected').each(function() {
            clubName = $(this).attr("data-sz_club_name");
            teamName = $(this).attr("data-sz_team_name");
            playerFirstName = playerLastName = "";
            if ($(this).attr("data-sz_player_first") != undefined) {
                playerFirstName = $(this).attr("data-sz_player_first");
            }
            if ($(this).attr("data-sz_player_last") != undefined) {
                playerLastName = $(this).attr("data-sz_player_last");
            }
            playerNumber = $(this).attr("data-sz_player_number");
            club_id = $(this).attr("data-sz_club_id");
            team_id = $(this).attr("data-sz_team_id");
            player_id = $(this).attr("data-sz_player_id");
            player_row_id = $(this).attr("data-sz_player_row_id");
          custom_field_name = $(this).attr("data-sz_custom_field_name");
           custom_field_value = $(this).attr("data-sz_custom_field_value");
          
            $('#sz_club_name').val(clubName);
            $('#sz_team_name').val(teamName);
            $('#sz_player_first').val(playerFirstName);
            $('#sz_player_last').val(playerLastName);
            $('#sz_player_number').val(playerNumber);
            $('#sz_club_id').val(club_id);
            $('#sz_team_id').val(team_id);
            $('#sz_player_id').val(player_id);
          $('#sz_custom_field').val(custom_field_name);
            $('#sz_custom_value').val(custom_field_value);
            if (document.querySelector('#sz_selectedPlayerName') !== null) {
                $('#sz_selectedPlayerName').html(playerFirstName + ' ' + playerLastName);
            }
            applyplayerSelection(player_row_id);
        });
    });
});

function popupdropdownteamsListCallback(response) {
    teamsData.teams = response;
    if (document.querySelector('#custom_teams_template') !== null) {
        var source = document.querySelector("#custom_teams_template").innerHTML;
        var template = Handlebars.compile(source);
        var html = template(teamsData);
        var destination = document.querySelector(".custom_popup_team_list");
        destination.innerHTML = html;
    }
  searchParams = new URLSearchParams(window.location.search);
   var teamSegment = searchParams.get('team');
  if(teamSegment=='non-team'){
    ///alert(teamSegment);
    var sel = document.getElementById('popup_team_list');
//var button = document.getElementById('button');

    //document.getElementById("nos").style.color = "blue";
//nos
    sel.options[1].selected = true;
    sel.onchange();

   //jQuery('#popup_team_list').find('option')[0].selected=true;
  }
    if (document.querySelector('#custom_player_manual_template') !== null) {
        var source = document.querySelector("#custom_player_manual_template").innerHTML;
        var template = Handlebars.compile(source);
        var html = template(teamsData);
        var destination = document.querySelector(".custom_popup_player_manual_input");
        destination.innerHTML = html;
    }
    var clubImagePath = "";
    var clubTitle = "Club Unavailable";
  
  
  	if (response.data != undefined) {
      teamsClubResponse = response.data.club_info;
    } else {
      teamsClubResponse = response.club_info;
    }
  /* update club type in cookie */
  
  	if (teamsClubResponse != undefined && teamsClubResponse != null) {
          // setCookie('isRosteredClub',teamsClubResponse.is_rostered);
     document.cookie = `isRosteredClub=${teamsClubResponse.is_rostered}`;

      currentClubId = teamsClubResponse.id;
      clubIsSkipPlayer = teamsClubResponse.is_skipPlayer;
      clubIsByPassLogin = teamsClubResponse.is_bypassLogin;

    }

    if (teamsClubResponse && teamsClubResponse.banner_message) {
      const bannerRow = document.querySelector('.custom-banner');
      const bannerText = document.getElementById('customBannerMessage');
      
      if (bannerRow && bannerText) {
        bannerText.textContent = teamsClubResponse.banner_message;
        bannerRow.style.display = 'block';
      }
    }
  
  
    if (response.data != undefined) {
      if (teamsClubResponse != undefined && teamsClubResponse != null) {
        clubImagePath = teamsClubResponse.club_image_url;
        clubTitle = teamsClubResponse.title;
      }

      /* If the current page is product details page we don't need the player selection siderbar, so that i've done the below changes */
      
      var siteUrlOnly = window.location.href.split('?')[0];
      var segments = siteUrlOnly.split( '/' );
        if(segments[3]=="products"){
          $(".playerslistsidebar").css("display","none");
          
        }
        else{
          $(".playerslistsidebar").css("display","block");
        }
        
      
        $(".club-right-sidebar").removeClass("col-md-12").addClass("col-md-10");
    } else {
      //$(".playerslistsidebar").css("display","none");
      $(".playerslistsidebar").remove();
      $(".club-right-sidebar").removeClass(".col-md-10").addClass("col-md-12");
    }

    if (clubIsSkipPlayer == 1) {
        $(".custom_players_list1,.prod-dtl-player-selection").css("display", "none");
        $(".shopify-payment-button__button").css("display", "block");
        $(".shopify-payment-button__button").prop("disabled", false);
        $(".close_player_popup").trigger("click");
        $("#warningPlayerSelection").remove();

        $(".playerslistsidebar").remove();
        $(".club-right-sidebar").removeClass(".col-md-10").addClass("col-md-12");
    }
    $("#club_image_path").attr("src", clubImagePath);
    $("#club_name").html(clubTitle);
  	//document.cookie = "previousCollectionClub=" + clubTitle + ";path=/";
}

function popupGetPlayers(teamID) {
    if (teamID != "") {
        //var playersListUrl = appBaseUrl+"api/playerSelector/"+teamID+"/playersByTeam?userReferenceId="+userReferenceId+"&operation=popupdropdown";
        var playersListUrl = appBaseUrl + "api/playerSelector/" + teamID + "/playersByTeam?userReferenceId=" + userReferenceId + "&operation=popupdropdown";
        var playersData = {
            players: [],
            siteBaseUrl: siteBaseUrl,
        };
        $.ajax({
            type: 'GET',
            url: playersListUrl,
            dataType: "jsonp",
        });
    } else {
        playersList = "<option value=''>Select</option>";
        $("#popup_players_list,#player_number").html(playersList);
    }
}

function popupdropdownplayersListCallback(response) {
    if (response.data.player_options.select_player_name == "dropdown") {
        player_operations = "existing_all";
    } else {
        player_operations = "new_player_name_only";
        if (response.data.player_options.select_player_number == "dropdown") {
            player_operations = "new_player_name_and_player";
        }
    }
    playersList = playerNumbersList = "<option value=''>Select</option>";
    $.each(response.data.result, function(key, value) {
        playersList += "<option value='" + value.id + "'>" + value.player_first + " " + value.player_last + " (#" + value.player_number + ")</option>";
    });
    $("#popup_players_list").html(playersList);
    if (response.data.player_options.select_player_number == "dropdown") {
        $.each(response.data.player_options.player_numbers, function(key, value) {
            playerNumbersList += "<option value='" + value + "'>#" + value + "</option>";
        });
        $("#player_number").html(playerNumbersList);
    }

 if(response.data.club_info.is_rostered == 0 && response.data.club_info.is_playerNumber == 1){
    $('#playernum-pop').css('display','block');
      var alreadySelectedPlayers ;
      var playerNumberUrl = appBaseUrl +'api/getaddedPlayerNumber?clubId='+response.data.club_info.id+'&teamId='+response.data.team_info.id;
      $.ajax({
          type: 'GET',
          url: playerNumberUrl,
          dataType: 'json',
          async: false,
          success: function (playerNumber) {
            alreadySelectedPlayers = playerNumber
          },
          error: function(xhr, status, error) {
            console.error('Error fetching player numberdata:', error);
          }
        });
      
        $('#player_number').empty();
        var option_blank = '<option value="">Select Player Number</option>'
        $('#player_number').append(option_blank)
      
     // Extract player numbers from the array of objects
    let selectedPlayerNumbers = alreadySelectedPlayers.map(player => parseInt(player.player_number));
    let reservedNumbers = response.data.team_info.playerNumbers_reserved.split(',').map(num => parseInt(num));
    
    for (let i = response.data.team_info.playerNumbers_min; i <= response.data.team_info.playerNumbers_max; i++) {
      let isDisabled = selectedPlayerNumbers.includes(i) || reservedNumbers.includes(i);
      // let isDisabled = selectedPlayerNumbers.includes(i);
      let disabledAttr = isDisabled ? "disabled" : "";
      let styleAttr = isDisabled ? "style='background-color: gray; color: white;'" : "";
      let $option = "<option value='" + i + "' " + disabledAttr + " " + styleAttr + ">#" + i + "</option>";
      $('#player_number').append($option);
    }
  }

  
}


function savePlayerSelection() {
    $(".popup_error").html("");
    playerMethod = player_operations;
    playerId = $("#popup_players_list option:selected").val();
    teamId = $('#popup_team_list :selected').val();
  
    if (playerMethod == "existing_all") {
        if (teamId == "") {
            $("#popup_team_list_warn").html("This field is required");
            return false;
        } else if (playerId == "") {
            $("#popup_players_list_warn").html("This field is required");
            return false;
        }
    } else if (playerMethod == "new_player_name_and_player") {
        if (teamId == "") {
            $("#popup_team_list_warn").html("This field is required");
            return false;
        } else if ($("#players_first_name").val() == "") {
            $("#players_first_name_warn").html("This field is required");
            return false;
        } else if ($("#players_last_name").val() == "") {
            $("#players_last_name_warn").html("This field is required");
            return false;
        } else if ($("#player_number option:selected").val() == "") {
           // $("#player_number_warn").html("This field is required");
           // return false;
        }
    } else if (playerMethod == "new_player_name_only") {
        if (teamId == "") {
            $("#popup_team_list_warn").html("This field is required");
            return false;
        } else if ($("#players_first_name").val() == "") {
            $("#players_first_name_warn").html("This field is required");
            return false;
        } else if ($("#players_last_name").val() == "") {
            $("#players_last_name_warn").html("This field is required");
            return false;
        } else if (playerId == "") {
            $("#popup_players_list_warn").html("This field is required");
            return false;
        }
    } else {
        $("#popup_team_list_warn").html("This field is required");
        return false;
    }
    saveExistingPlayersSelection(playerId, teamId, playerMethod);
}

function saveExistingPlayersSelection(playerId, teamId, playerMethod) {
    playerFirstName = $("#players_first_name").val();
    playerLastName = $("#players_last_name").val();
    var playerNumber = $("#player_number").val();
   playercustomoption = $("#custom_size").val();
    playercustomlable = $("#custom_lable").val();
    tempPlayerRowId = "";
    isTempPlayerSelected = 0;
  var club_id_slug = $('#club_id_slug').val();  
  
    $.ajax({
        headers: {
            Accept: "application/json; charset=utf-8",
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: appBaseUrl + 'api/playerSelector/storePlayerTemp?operation=popupdropdown',
        type: 'GET',
        data: {
            playerFirstName: playerFirstName,
            playerLastName: playerLastName,
            playerNumber: playerNumber,
            playercustomlable: playercustomlable,
            playercustomoption: playercustomoption,
            playerMethod: playerMethod,
            userReferenceId: userReferenceId,
            playerId: playerId,
            teamId: teamId,
            customerId: customerId,
            customerEmail: customerEmail,
          club_slug : club_slug
        },
        dataType: "jsonp",
    });
}

function popupdropdownstorePlayerTempCallback(data) {
    if (data.status != "success") {
        setCookie('getPlayerDetail', JSON.stringify(data));
        
        toastr.options = {
            "closeButton": true,
            "progressBar": true,
            "timeOut": "5000",
        }

        if (data.duplicate_info && data.duplicate_info.is_duplicate === true) {
            toastr['error'](data.message);
        }else{
            var loginMessage = '<a href="https://soccerzoneusa.com/account/login" class="btn btn-sz-red form-control mt-2">Click here to login</a>Please try to login and try once again.';
            toastr['error'](data.message);
            toastr['success'](loginMessage);
        }

        return false;
    }
    if (data.status == "success") {
        lastPlayerSelectionId = data.player_last_id;

        setCookie('getPlayerDetail', JSON.stringify(data.player));
        setCookie('clubTempPlayer', JSON.stringify(data.club));``
    }
    $("#popup_player_selection")[0].reset();
    $(".close_player_popup").trigger("click");
    operation = "";
    $.ajax({
        type: 'GET',
        url: playersListUrl + "&operation=" + operation + "&resultFor=product_list",
        dataType: "jsonp",
    });
    toastr.options = {
        "closeButton": true,
        "progressBar": true,
        "timeOut": "5000",
    }
    if (document.querySelector('.custom_players_dd_template') !== null) {
        $.ajax({
            type: 'GET',
            url: playersListUrl + "&operation=dropdown&resultFor=",
            dataType: "jsonp",
        });
    }
    toastr['success'](data.message);
}

function applyplayerSelection(temp_player_id) {
  //alert('applyplayerSelection');
  	
  $("#player_selection_id").val(temp_player_id);
  //alert("Var - "+previouslySelected);
  //alert("Cookie read "+getCookie("previouslySelected"));
  /* New player selection content - START */
  show_player_names_nps = $(".show_player_names_"+temp_player_id).html();
  show_player_number_nps = $(".show_player_number_"+temp_player_id).html();

  if (show_player_number_nps != undefined) {
  	$(".nps-number").html("#"+show_player_number_nps);
  }
  $(".nps-name").html(show_player_names_nps);
  /* New player selection content - END */
	/* Old player selection content - START */
  previouslySelected = getCookie("previouslySelected");

  if (previouslySelected != "") {
    $(".old-player-selection").css("display","block");
    show_player_names_ops = $(".show_player_names_"+previouslySelected).html();
    show_player_number_ops = $(".show_player_number_"+previouslySelected).html();

    if (show_player_number_ops != undefined && show_player_number_ops != "") {
      $(".ops-number").html("#"+show_player_number_ops);
      $(".num-rounded").css("display","block");
    } else {
      $(".num-rounded").css("display","none");
    }
    $(".ops-name").html(show_player_names_ops);
  } else {
    $(".old-player-selection").css("display","none");
  }
  /* Old player selection content - END */
  $("#switchPlayerModal").css("display", "block");
}

function confirmSwitchPlayer() {
  temp_player_id = $("#player_selection_id").val();
    lastPlayerSelectionId = temp_player_id;
    clubName = $(".temp_player_btn_" + temp_player_id).attr("data-sz_club_name");
    teamName = $(".temp_player_btn_" + temp_player_id).attr("data-sz_team_name");
    playerFirstName = $(".temp_player_btn_" + temp_player_id).attr("data-sz_player_first");
    playerLastName = $(".temp_player_btn_" + temp_player_id).attr("data-sz_player_last");
    playerNumber = $(".temp_player_btn_" + temp_player_id).attr("data-sz_player_number");
    club_id = $(".temp_player_btn_" + temp_player_id).attr("data-sz_club_id");
    team_id = $(".temp_player_btn_" + temp_player_id).attr("data-sz_team_id");
    player_id = $(".temp_player_btn_" + temp_player_id).attr("data-sz_player_id");
  	hasOrdered = $(".temp_player_btn_" + temp_player_id).attr("data-sz_has_ordered");
  
  	skipRequired = $(".temp_player_btn_" + temp_player_id).attr("data-sz_skip_required");
  
  	playerProductTag = $(".temp_player_btn_" + temp_player_id).attr("data-sz_player_tag");
  	playerRequiredTags = $(".temp_player_btn_" + temp_player_id).attr("data-sz_required_slug");
   customField = $(".temp_player_btn_" + temp_player_id).attr("data-sz_custom_field_name");
  customValue = $(".temp_player_btn_" + temp_player_id).attr("data-sz_custom_field_value");
	//alert(playerProductTag);
  
    $('#sz_club_name').val(clubName);
    $('#sz_team_name').val(teamName);
    $('#sz_player_first').val(playerFirstName);
    $('#sz_player_last').val(playerLastName);
    $('#sz_player_number').val(playerNumber);
    $('#sz_club_id').val(club_id);
    $('#sz_team_id').val(team_id);
    $('#sz_player_id').val(player_id);
    $('#temp_player_row_id').val(temp_player_id);
    $('#is_temp_player_selected').val(1);
  $('#sz_custom_field').val(customField);
    $('#sz_custom_value').val(customValue);
    tempPlayerRowId = temp_player_id;
    isTempPlayerSelected = '1';
    $(".temp_player_btn").find('svg').attr('data-icon', 'hand-pointer');
    $(".temp_player_btn_" + temp_player_id).find('svg').attr('data-icon', 'check');
    $(".playerRows").removeClass("player_highlight");
    $(".playerRow_" + temp_player_id).addClass("player_highlight");
  	if (hasOrdered == 0) {
  		//$(".filter-link-required").attr("data-tag",playerProductTag);
      	$(".filter-link-required").attr("data-tag",playerRequiredTags);

        if (skipRequired == 1) {
             applyRequiredTag("required", 'remove','','');
        }else{
           applyRequiredTag(playerProductTag, 'add',temp_player_id,playerRequiredTags);
        }
         
          applyPurchasedTag('remove', '');
        
    } else {
      $(".filter-link-required").attr("data-tag","required");
      applyRequiredTag("required", 'remove','','');
      applyPurchasedTag('add', temp_player_id);
    }
  
    if ($(".filter-link-required").hasClass("active") == true) {
      //$('.filter-link-required').get(0).click();
    }  
  
  	if (hasOrdered == 1) {
      $(".required-collection-icon").css("display", "none");
    } else {
      $(".required-collection-icon").css("display", "contents");
    } 
  
    if (document.querySelector('#playerSelection') !== null) {
        $('#playerSelection option[data-sz_player_row_id=' + temp_player_id + ']').attr('selected', 'selected');
    }
    if (playerFirstName != undefined) {
        if (document.querySelector('.shopify-payment-button__button') !== null) {
            $(".shopify-payment-button__button").css("display", "block");
            $(".shopify-payment-button__button").prop("disabled", false);
        }
      	previouslySelectedVal = getCookie("currentlySelected");
	//alert(temp_player_id);
      	document.cookie = "currentlySelected=" + temp_player_id + ";path=/";
      	document.cookie = "previouslySelected=" + temp_player_id + ";path=/";     
      
      	document.cookie = "currentlySelected_"+shopifyCollectionId+"=" + temp_player_id + ";path=/";
      	document.cookie = "previouslySelected_"+shopifyCollectionId+"=" + temp_player_id + ";path=/";

     	overallSelectedJsonRead = getCookie("overallSelected");
        
        if (overallSelected == "" || overallSelected == undefined) {
          overallSelected = [];
        } else {
          overallSelected = JSON.parse(overallSelectedJsonRead);
        }
      	temp_player_id = parseInt(temp_player_id);
      	overallSelected.push(temp_player_id);
      
        var overallSelectedNew = overallSelected.filter(function(elem, index, self) {
          return index === self.indexOf(elem);
        });

      	overallSelectedJson = JSON.stringify(overallSelectedNew);
      	document.cookie = "overallSelected=" + overallSelectedJson + ";path=/";
      
      	$(".close_player_switch_popup").trigger("click");      
      
      	updatePlayerSelectionText();     
      
        toastr.options = {
            "closeButton": true,
            "progressBar": true,
            "timeOut": "5000",
            //"extendedTimeOut": "10000",
        }
      if(teamName=="non-team"){
        teamName="";
      }else{
        teamName="-"+teamName
      } 
        successMsg = "<strong>You have set your current player:</strong><br/> " + playerFirstName + " " + playerLastName + teamName;
        if (playerNumber != "") {
            successMsg += " - Player #" + playerNumber;
        }
        //toastr['success'](successMsg);

      if (requiredTagPageLoad == 0) {       
        var requiredRedirectUrl = $(location).attr('href').split("/").splice(0, 5).join("/");
        //alert(requiredRedirectUrl+"/"+playerRequiredTags);
        window.location.href = requiredRedirectUrl+"/"+playerRequiredTags;        
      } else {
        requiredTagPageLoad = 0;
        toastr['success'](successMsg);
      }
    } else {
        if (document.querySelector('.shopify-payment-button__button') !== null) {
            $(".shopify-payment-button__button").prop("disabled", true);
        }
    }
}

function closeSwitchPlayer() {
  $("#switchPlayerModal").css("display", "none");
}

function updatePlayerSelectionText() {
  /* Update "Ordered" Text - start */
  overallSelected = getCookie("overallSelected");
  playerRowEach = 1;
  $('.playerWrapper').each(function() {
	$(".player-row-each-"+playerRowEach).html("Select Player "+playerRowEach);
    playerRowEach++;
  });

  if (overallSelected != "") {
    $(".playerWrapper").removeClass("currentlySelected previouslySelected");
    overallSelectedDecode = JSON.parse(overallSelected);
    orderedText = "<span style='color:red;'>ORDERED</span>";
    $.each( overallSelectedDecode, function( key, value ) {
      $(".playerWrapper_"+value).addClass("previouslySelected");
      //$(".selected_staus_update_"+value).html(orderedText);
    });
    /* Update "Selected" Text - end */
    currentlySelected = getCookie("currentlySelected");
    selectedText = "<span style='color:green;'>SELECTED</span>";
    $(".playerWrapper_"+currentlySelected).removeClass("previouslySelected");
    $(".playerWrapper_"+currentlySelected).addClass("currentlySelected");
    //$(".selected_staus_update_"+currentlySelected).html(selectedText);
    $(".select-player-"+currentlySelected).html("Selected");
    $(".temp_player_btn").prop("disabled", false);
    $(".temp_player_btn_"+currentlySelected).prop("disabled", true);
    
    //csPlayerNumber
    showSelectedPlayerNumber = $(".show_player_number_"+currentlySelected).html();
    if (showSelectedPlayerNumber && showSelectedPlayerNumber != undefined) {
      $(".csPlayerNumber").html("#"+showSelectedPlayerNumber);
    } else {
      $(".csPlayerNumber").html("");
    }
    
    showSelectedPlayerNames = $(".show_player_names_"+currentlySelected).html();
    if (showSelectedPlayerNames != undefined) {
      $(".currentlyShopping").css("display","block");
      $(".csPlayerName").html(showSelectedPlayerNames);
    } else {
      deleteCookie("clubTempPlayer");
      $(".csPlayerName").html("Sorry, Not Selected Player Yet.");
     // $(".currentlyShopping").css("display","none");
    }
  }
  	
   //$(".product-hide").remove();
  if ($('body').data('template') == "collection") {
    $(".product-hide").css("display","block");
  } else {
    $(".product-hide").css("display","none");
  }

  /* ADDED FOR NON ROASTERD CLUB - FOR NON ROASTERED CLUB PLAYER DETAILS NOT DISPLYED SO THAT HERE I"VE ADDED BELOW LINE - BUT IN DEV NOT THE SAME WAY */
  $('.custom_players_list1').css('display',"block");
  /* Update "Selected" Text - end */
}

function applyRequiredTag(playerProductTag, type, tempPlayerId,playerRequiredTags) {
  //alert('applyRequiredTag');
  var requiredProdCount = 0;
  if (type == 'add') {
    var tag = playerProductTag;
    $('.product-filter').each(function(i, obj) {
      $(this).find(".required-ribbon-count").html("");
      $(this).find(".quantity").val(1);
      $(this).find(".quantity").attr("min", 1);
      requiredQty = 1;
      var tagsString = $(this).attr("tags");
      // var tags = tagsString.split(",");
      // Safely handle cases where tags might be undefined/null
      if (tagsString) {
        var tags = tagsString.split(",").map(function(tag) {
          return tag.trim().toLowerCase(); 
        });
      } else {
        var tags = []; // Handle empty/undefined case
      }
      
      $(tags).each(function(tagIndex, tagObj){
        secondParamValid = false;
        requiredProduct = false;
        tagSplittedArr = tagObj.split(tag);
        
          
        if(tagObj==="required-non"){
           $(this).find(".required-ribbon").css("display", "block");
           requiredProduct = true;
            return false;
          }  
      
        if (tagSplittedArr.length > 1) {
          if (tagSplittedArr[1] != "" ) {
          	tagSplittedSecond = tagSplittedArr[1];
            tagSplittedSecond = tagSplittedSecond.substring(1);
            if ($.isNumeric(tagSplittedSecond) == true) {
              secondParamValid = true;
              requiredQty = tagSplittedSecond;
            }
           // alert(tagSplittedSecond);
          }
         // alert(tagSplittedArr[0]+" --- "+secondParamValid+" --- "+tagSplittedArr[1]);
         // alert(tagSplittedSecond);
         // alert(tagSplittedSecond.substring(1));
          //alert(tagSplittedArr[0]+" ---- "+secondParamValid);
          
          if ((tagSplittedArr[0] == "" && secondParamValid ==  true) || (tagSplittedArr[0] == "" && tagSplittedArr[1] == "")) {
            requiredProduct = true;
            return false;
          }
          
        }
      });
//alert(requiredProduct+" ----- "+requiredQty);
      //alert(tags.indexOf(tag));
      //if(tags.indexOf(tag) > -1) {
      if (requiredProduct == true) {
        requiredProdCount = parseInt(requiredProdCount) + 1;
        $(this).find(".required-ribbon").css("display", "block");
        requiredQty = parseInt(requiredQty);
        if (requiredQty > 1) {
        	$(this).find(".required-ribbon-count").html(" (x"+requiredQty+")");
        	$(this).find(".quantity").val(requiredQty);
          	$(this).find(".quantity").attr("min", requiredQty);
        }
      } else {
        $(this).find(".required-ribbon").css("display", "none");
      }
    });
  } else {
    $(".required-ribbon").css("display", "none");
  }
  //alert(tags);
  //if (requiredProdCount > 0) {
  //if(typeof tags !== 'undefined' && $.inArray(playerProductTag, tags) != -1) {
  if(typeof tags !== 'undefined' && $.inArray(playerRequiredTags, tags) != -1) {
   // $('.filter-link-required').addClass("btn btn-sm btn-sz-red active");
    $('.filter-link-required').css("display", "block");
    //$('.filter-link-required').get(0).click();
  } else {
    $('.filter-link-required').css("display", "none");
   // alert('hello - sss');
    if ($('.filter-link-all').length > 0) {
    	//$('.filter-link-all').get(0).click();
    }
  }
}

function applyPurchasedTag(type, tempPlayerId) {
  $(".purchased-ribbon").css("display", "none");
  if (type == 'add') {
    orderedProducts = $(".temp_player_btn_" + tempPlayerId).attr("data-sz_ordered_products");
    //alert(orderedProducts);
    if (typeof orderedProducts !== 'undefined' && orderedProducts != "") {
      
      var orderProductIds = orderedProducts.split(',');
      $.each(orderProductIds, function(index, value) { 
        //alert(".product_id_"+value);
        $(".product_id_"+value).find(".purchased-ribbon").css("display", "block");
      });

    }
  } else {
    $(".purchased-ribbon").css("display", "none");
  }
}

function deleteCookie(name) {
    document.cookie = name + '=; expires=; path=/;';
  console.log("deletecookie");
}